// src/api/FetchUserVendorProfiles.ts
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore, auth } from '../config/FirebaseConfig';
import toCamelCase from '../logic/toCamelCase';
import { Participant } from '../data/classes/Participant';

const FetchUserVendorProfiles = async (): Promise<Participant[]> => {
  const userVendorProfiles: Participant[] = [];

  if (auth.currentUser) {
    const q = query(
      collection(firestore, "Vendors"),
      where("UserID", "==", auth.currentUser.uid)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.docs.forEach((doc) => {
      userVendorProfiles.push(
        toCamelCase({ id: doc.id, ...doc.data() }) as Participant
      );
    });
  }

  return userVendorProfiles;
};

export default FetchUserVendorProfiles;
